import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: 0;
  padding: 0 8px;
  box-sizing: border-box;

  @media (min-width: 400px) {
    padding: 0 16px;
  }
`;

const DropZone = styled.div<{ isDragOver: boolean; $atMax: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 140px;
  padding: 24px 16px;
  border: 2px dashed ${(props) => (props.isDragOver ? props.theme.colors.main_cta : props.theme.colors.inactive)};
  border-radius: 12px;
  background: ${(props) => props.theme.colors.widget_background};
  cursor: ${(props) => (props.$atMax ? 'not-allowed' : 'pointer')};
  transition: border-color 0.2s, background 0.2s;

  ${(props) => props.$atMax && `
    opacity: 0.85;
  `}

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.main_cta};
  }
  @media (min-width: 360px) {
    min-height: 160px;
    padding: 28px 20px;
  }
`;

const DropZoneIcon = styled.span`
  font-size: 32px;
`;

const DropZoneText = styled.p`
  margin: 0;
  font-size: 14px;
  text-align: center;
  color: ${(props) => props.theme.colors.text};

  &:last-of-type {
    font-size: 12px;
    color: ${(props) => props.theme.colors.inactive};
  }
  @media (min-width: 360px) {
    font-size: 15px;
    &:last-of-type {
      font-size: 13px;
    }
  }
`;

const DropZoneHint = styled.p`
  margin: 0;
  font-size: 12px;
  text-align: center;
  color: ${(props) => props.theme.colors.main_cta};
`;

const RulesList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.inactive};

  li {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .check {
    color: ${(props) => props.theme.colors.green};
    flex-shrink: 0;
  }
`;

const FileListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

const FileListScroll = styled.div`
  max-height: 120px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.widget_background};
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.inactive};
    border-radius: 4px;
  }
`;

const FileItem = styled.div<{ hasError?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.hasError ? props.theme.colors.red : props.theme.colors.outline)};
  background: ${(props) => props.theme.colors.widget_background};
  min-width: 0;

  @media (min-width: 400px) {
    gap: 16px;
    padding: 12px 16px;
  }
`;

const PlayIcon = styled.span`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.inactive};
  img {
    border-radius: 4px;
  }
`;

const FileInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: baseline;
  gap: 6px;
`;

const FileName = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.text};
  overflow: hidden;
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const FileMeta = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.inactive};
`;

const FileError = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.red};
  width: 100%;
`;

const RemoveButton = styled.button`
  flex-shrink: 0;
  padding: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors.inactive};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: ${(props) => props.theme.colors.red};
  }

  &:focus {
    outline: none;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export default {
  Wrapper,
  DropZone,
  DropZoneIcon,
  DropZoneText,
  DropZoneHint,
  RulesList,
  FileListSection,
  FileListScroll,
  FileItem,
  PlayIcon,
  FileInfo,
  FileName,
  FileMeta,
  FileError,
  RemoveButton,
  Actions,
};
